import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Body from "./Body";
import { BsFillPersonFill } from "react-icons/bs";
import { FcLock } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

const NewPassword = () => {
  let navigate = useNavigate();
  return (
    <div>
      <Navbar />
      <div className="main-containerr bgclr">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Body />
            </div>

            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <div className="main-form mt-5">
                <div>
                  <div className="Info text-white">
                    <h3 className=" text-white mb-3">RAFFLE MANIA</h3>

                    <p className="mt-3">
                      Enter the new password to access your account.
                    </p>
                    <form className="mt-3 mb-4 formInputs">
                      <label for="pwd">PASSWORD</label>
                      <div className="form-group d-flex">
                        <input
                          type="password"
                          className="forgotInput"
                          id="pwd"
                          placeholder="*******"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                      <label for="pwd2">RE PASSWORD</label>
                      <div className="form-group d-flex">
                        <input
                          type="password"
                          className="forgotInput"
                          id="pwd2"
                          placeholder="*******"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <BsFillPersonFill />
                          </span>
                        </div>
                      </div>
                    </form>

                    <div className="mt-3 pr-5 pl-1 btnDiv3">
                      <button
                        type="button"
                        className="btn w-100 mb-1  bg-white modlbtn"
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        Log In
                      </button>

                      <div className="modal fade" id="myModal">
                        <div className="modal-dialog ">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h4 className="modal-title text-dark text-center">Hurrah!</h4>
                            </div>

                            <div className="modal-body text-dark text-center">
                                <h1 className=" display-2"><FcLock/></h1>
                              Your Account’s Password is Reseted.
                            </div>

                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary w-50"
                                data-dismiss="modal"
                                onClick={()=>navigate("/")}
                              >
                                Continue
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NewPassword;
